export enum formType {
    ADD = "Add",
    EDIT = "Edit",
    DELETE = "Delete"
  }

  export enum ddlOptions {
    MALE = "Male", 
    FEMALE = "Female", 
    PARENT = "Parent",
    GRANDPARENT = "Grandparent",
    AUNT_UNCLE = "Aunt/Uncle",
    FRIEND = "Friend",
    SELF = "Self",
    SPOUSE = "Spouse",
    OTHER = "Other",    
    PREFER_NOT_TO_SAY = "Prefer Not To Say"
  }